import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import QuestionImage from "../../assets/images/questionInfo/selfLove.webp";

const QuestionInfo = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="bg-background w-full max-w-[1039px] h-auto mx-auto mt-12 md:mt-24 p-6 md:p-8 rounded-[30px] md:rounded-[50px] shadow-lg">
      {/* Go Back Button */}
      <button
        className="flex items-center w-[100px] md:w-[117px] h-[35px] md:h-[39px] border-[1px] md:border-[1px] border-cards-border rounded-[10px] md:rounded-[15px] text-white bg-button-bg font-poppins text-[12px] md:text-[14px] mb-6 md:mb-8"
        onClick={() => navigate("/signUp")}
      >
        <span className="w-[20px] md:w-[24px] h-[20px] md:h-[24px] flex items-center justify-center">
          &#10094;
        </span>
        {t("goToBack")}
      </button>

      {/* Welcome Banner */}
      <div className="w-full max-w-[614px] mx-auto mb-6 bg-button-bg bg-opacity-10 border border-cards-border rounded-[20px] md:rounded-[30px] p-5 md:p-6 text-center">
        <h3 className="text-[18px] md:text-[22px] font-poppins font-bold text-button-bg mb-3">
          {t("questionWelcomeTitle")}
        </h3>
        <p className="font-poppins text-[13px] md:text-[15px] text-[#454545] leading-relaxed">
          {t("questionWelcomeText")}
        </p>
      </div>

      {/* Main Content */}
      <div className="bg-selectedbackground w-full max-w-[614px] h-auto p-6 md:p-8 mx-auto rounded-[30px] md:rounded-[50px] shadow-md flex flex-col items-center">
        <img
          src={QuestionImage}
          alt="Heart Illustration"
          className="max-w-[50%] md:max-w-[206px] h-auto mt-[-10px] md:mt-[-20px]"
        />
        <h2 className="text-[20px] md:text-[24px] font-poppins font-bold text-[#454545] text-center mt-[20px] md:mt-[25px]">
          {t("questionInfoTitle")}
        </h2>
        <div className="w-full max-w-[562px] h-auto mt-[25px] md:mt-[35px]">
          <p className="font-poppins text-[16px] md:text-[20px] text-[#454545] break-words text-center">
            {t("questionInfoDescription-1")} <br />
            {t("questionInfoDescription-2")}
          </p>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-4 w-full mt-[30px] md:mt-[43px] justify-center">
        {/* Cancel Button */}
        <button
          className="w-full max-w-[50%] sm:max-w-[45%] md:max-w-[476px] h-[45px] md:h-[61px] bg-[#abafab] text-white text-[14px] sm:text-[16px] md:text-[20px] font-poppins font-bold rounded-[15px] md:rounded-[30px] transition hover:bg-[#E5D3DD]"
          onClick={() => navigate("/signUp")}
        >
          {t("cancel")}
        </button>

        {/* Let's Start Button */}
        <button
          className="w-full max-w-[50%] sm:max-w-[45%] md:max-w-[476px] h-[45px] md:h-[61px] bg-button-bg text-white text-[14px] sm:text-[16px] md:text-[20px] font-poppins font-bold rounded-[15px] md:rounded-[30px] transition hover:bg-[#216324]"
          onClick={() => navigate("/questions/1")}
        >
          {t("letsStart")}
        </button>
      </div>
    </div>
  );
};

export default QuestionInfo;